const VoiceTerms = Object.freeze({
  NAME: 'start',
  PAGE_FUNCTION: 'login',
  PAGE_SUBFUNCTION: 'login'
})

export default VoiceTerms
